<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA;">
    <!-- <h2 class="txt-head">
      เพิ่มบริษัทใหม่
    </h2> -->
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          ข้อมูลลงทะเบียนธุรกิจ
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn width="18%" class="ma-0" outlined color="#3776E9" dark @click="copyData()">คัดลอก</v-btn>
        <v-btn width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="dialogApproverCompany = true">ยกเลิกเอกสาร</v-btn>
      </v-col>
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div>
      <v-expansion-panels
        accordion
        v-model="panel"
        multiple
        class="pb-5"
      >
        <v-expansion-panel>
          <v-expansion-panel-header color="#FFFFFF" class="ra-head-text-bold" style="font-size: 16px;">ข้อมูลบริษัท</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="">
              <v-col cols="12" class="pl-5">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="pl-5">
                  <span class="txt-head">รูปแบบธุรกิจ</span>
                </v-col>
                <!-- <div class="pl-5">
                  <span class="txt-font">รูปแบบธุรกิจ</span>
                  <v-radio-group
                    v-model="businessType"
                    row
                    >
                    <v-radio
                      class="radio-border"
                      label="ธุรกิจ(ร้านค้า)"
                      value="ธุรกิจ(ร้านค้า)"
                    ></v-radio>
                    <v-radio
                      class="radio-border"
                      label="นิติบุคคล"
                      value="นิติบุคคล"
                    ></v-radio>
                  </v-radio-group>
                </div> -->
                <v-col cols="4" class="form-control pl-5">
                  <p class="txt-font" style="margin-top: 0%;">รูปแบบธุรกิจ</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{businessType || '-'}}</p>
                </v-col>
              </v-row>
            <v-layout class="pa-2 pr-2" style="margin-top: -2%;" v-show="businessType === 'ธุรกิจ(ร้านค้า)'">
              <v-row>
                <!-- <v-col cols="12">
                  <v-divider></v-divider>
                </v-col> -->
                <v-col cols="12">
                  <span class="txt-head">รายละเอียดธุรกิจ</span>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทธุรกิจ</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{businessModelType || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อย่อธุรกิจภาษาไทย (ไม่จำเป็น)</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameShortTh || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มธุรกิจภาษาไทย*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameFullTh || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เบอร์โทรศัพท์</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyTelNo || '-'}}</p>
                </v-col>
                <!-- <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(ไทย)*</p>
                  <v-select
                    v-model="legalEntityTh"
                    :items="['ไม่มี','ห้างหุ่นส่วนสามัญ', 'ห้างหุ่นส่วนจำกัด', 'บริษัทจำกัด', 'บริษัทมหาชนจำกัด', 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ']"
                    label="กรุณาเลือกประเภทนิติบุคคล(ไทย)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-select>
                </v-col> -->
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อย่อธุรกิจอังกฤษ</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameShortEng || '-'}}</p>
                </v-col>
                <!-- <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(ไทย)*</p>
                  <v-text-field
                    v-model="nameUseInDocTh"
                    label="ชื่อสำหรับแสดงบนเอกสาร(ไทย)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col> -->
                <!-- <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(อังกฤษ)*</p>
                  <v-select
                    v-model="legalEntityEng"
                    :items="['None','Ordinary Partnership', 'Limited Partnership', 'Company Limited', 'Public Limited Company', 'Other']"
                    label="Please choose a legal entity"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-select>
                </v-col> -->
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มธุรกิจอังกฤษ*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameFullEng || '-'}}</p>
                </v-col>
                <!-- <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)*</p>
                  <v-text-field
                    v-model="nameUseInDocEng"
                    label="ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col> -->
                <!-- <v-col cols="4" md="3" sm="3" lg="4" xl="3">
                  <p class="txt-font" style="margin-top: 0%;">หนังสือรับรองนิติบุคคล</p>
                  <div class="box-image3 mt-1">
                  <v-row>
                    <v-col cols="7">
                      <span v-if="filesCertificate.length === 0" class="text-right ml-5" style="color: #999999; font-size: 12px; margin-top: 0%;">อัปโหลดหนังสือรับรองนิติบุคคล</span>
                      <input type="file" id="files" ref="PickfilesCertificate" multiple v-on:change="onFileSelected('certificate')"/>
                      <div v-for="(file, key) in filesCertificate" :name="file.name" class="file-listing ml-1 mt-0" :key="key">
                        <span class="mb-5" close :id="key" :name="file.name" @click:close="removeFile(key, 'certificate')" color=""><strong class="txt-font">{{ file.name }}</strong>&nbsp;</span>
                      </div>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        id="btnbrowse"
                        name="btnbrowse"
                        depressed
                        color="#EFF4FD"
                        class="ml-5"
                        small
                        style="margin-top: -38%; margin-right: -20%;"
                        v-on:click="addFiles('certificate')"
                        readOnly
                      >
                      <span class="txt-font ml-3" style="color: #3776E9;">เลือกไฟล์</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  </div>
                  <p class="txt-font" style="margin-top: 5%;">อัปโหลดได้เฉพาะไฟล์ .pdf เท่านั้น</p>
                </v-col> -->
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อีเมล(ไม่จำเป็น)</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{email || '-'}}</p>
                </v-col>
              </v-row>
            </v-layout>
            <v-layout class="pa-2 pr-2" style="margin-top: -2%;" v-show="businessType === 'นิติบุคคล'">
              <v-row>
                <!-- <v-col cols="12">
                  <v-divider></v-divider>
                </v-col> -->
                <v-col cols="12">
                  <span class="txt-head">รายละเอียดธุรกิจ</span>
                </v-col>
                <!-- <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเครือ</p>
                  <v-select
                    v-model="groupName"
                    :items="itemCompany"
                    item-text="groupCompanyNameEng"
                    item-value="_id"
                    label="เลือก เครือ"
                    dense
                    outlined
                  ></v-select>
                </v-col> -->
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อย่อบริษัท(ภาษาไทย)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameShortTh || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อย่อบริษัท(ภาษาอังกฤษ)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameShortEng || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(ภาษาไทย)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{legalEntityTh || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มบริษัท(ภาษาไทย)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameFullTh || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(ภาษาไทย)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{nameUseInDocTh || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(ภาษาอังกฤษ)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{legalEntityEng || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มบริษัท(ภาษาอังกฤษ)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyNameFullEng || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{nameUseInDocEng || '-'}}</p>
                </v-col>
                <v-col cols="4" md="3" sm="3" lg="4" xl="3">
                  <p class="txt-font" style="margin-top: 0%;">หนังสือรับรองนิติบุคคล</p>
                  <div class="mt-1">
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        id="btnbrowse"
                        name="btnbrowse"
                        right
                        rounded
                        color="#FFFFFF"
                        dark
                        class="mr-2 ml-2 pa-5 align-center btn_click"
                        style="cursor: unset;"
                      >
                        <v-icon left large color="#DE4F3B">mdi-pdf-box</v-icon>
                        <span class="txt-font">{{filesCertificateName}}</span>
                        <v-icon right dark color="#6B96F8" @click="downloadFile(filesCertificateId, filesCertificateName)">mdi-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-layout>
            <v-layout class="pa-5 pr-5 mt-5">
              <v-row>
                <v-col cols="12" class="from-control">
                  <span class="txt-head" style="font-weight: bold;">ที่อยู่บริษัท</span>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เลขรหัสประจำที่อยู่</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.codeAddress || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ที่อยู่*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.address || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ห้องเลขที่</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.roomNo || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชั้นที่</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.floorNo || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อาคาร</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.buildingName || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">หมู่บ้าน</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.villageName || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">หมู่ที่</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.villageNo || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ตรอก/ซอย</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.alley || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">แยก</p>
                  <p class="txt-font" style="margin-top: 0%;">{{companyAddressDetail.dispart || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ถนน</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.road || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">จังหวัด*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.province || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อำเภอ/เขต*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.district || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ตำบล/แขวง*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.subDistrict || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">รหัสไปรษณีย์*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyAddressDetail.postCode || '-'}}</p>
                </v-col>
                <v-col cols="5">
                  <p class="txt-font" style="margin-top: 0%;">รูปภาพ บริษัท*</p>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        class="base-image-input elevation-1"
                        :style="{ 'background-image': `url(${imageUrl})` }"
                      >
                        <span
                          v-if="!imageUrl"
                          class="placeholder-image"
                        >
                        </span>
                        <input
                          class="file-input"
                          id="files"
                          ref="Pickfiles"
                          type="file"
                          v-on:change="onBannerSelected()"
                        >
                      </div>
                    </template>
                    <span class="txt-font" v-if="imageUrl !== ''" style="color: white;">รูปภาพบริษัท</span>
                    <span class="txt-font" v-if="imageUrl === ''" style="color: white;">รูปภาพบริษัท</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-show="taxDetailType === 'มีข้อมูลผู้เสียภาษี'">
          <v-expansion-panel-header color="#FFFFFF" class="ra-head-text-bold" style="font-size: 16px;">ข้อมูลผู้เสียภาษี</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="" v-show="businessType === 'ธุรกิจ(ร้านค้า)'">
              <div class="pl-5">
                <span class="txt-font-value">{{taxDetailType}}</span>
              </div>
            </v-row>
            <v-layout class="pa-2 pr-2" v-show="businessType === 'นิติบุคคล' || taxDetailType === 'มีข้อมูลผู้เสียภาษี'">
              <v-row>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เลขที่ผู้เสียภาษีอากร*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{taxId || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อีเมล*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{email || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ภูมิภาค/Region*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{region || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสาขา*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{branchName || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">รหัสสาขา*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{branchCode || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เบอร์โทรศัพท์</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyTelNo || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เบอร์มือถือ*</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{companyMobilNumber || '-'}}</p>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">โทรสาร</p>
                  <p class="txt-font-value" style="margin-top: 0%;">{{fax || '-'}}</p>
                </v-col>
              </v-row>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header color="#FFFFFF" class="ra-head-text-bold" style="font-size: 16px;">ข้อมูลผู้ดูแล</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-if="approver.length === 0" class="mt-0 mb-8" justify=center>
              <v-col cols="8" class="text-center">
                <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลผู้ดูแล</span>
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="ra-head-text">คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มผู้ดูแลของคุณ</span>
              </v-col>
              <!-- <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
                <v-btn
                  outlined
                  class="ra-button"
                  dark
                  @click="openDialogAddAprover('add', '', '', 'approver')"
                >
                <v-icon left dark color="#fff" size="14px">fa-plus</v-icon>
                <span class="ra-text-in-button">
                  เพิ่มผู้ดูแล
                </span>
              </v-btn>
              </v-col> -->
            </v-row>
            <v-row v-else>
              <v-col cols="12"
              >
                <v-data-table
                  :hide-default-footer="true"
                  :headers="headers"
                  :items="approver"
                  sort-by="no"
                  class="elevation-0"
                >
                <template v-slot:[`item.no`]="{ item }">
                  {{ approver.indexOf(item)+1 }}
                </template>
                <template v-slot:[`item.userImg`]="{ item }">
                  <td style="width: fit-content !important;" class="py-3">
                    <v-avatar
                      size="44"
                      rounded
                      >
                      <v-img
                        class="card-header-userimg-border"
                        cover
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                        :alt="item.employeeId"
                        v-on:error="onImgError(i)"
                        aspect-ratio="1"
                        height="100%"
                      />
                    </v-avatar>
                    </td>
                </template>
                  <!-- <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        outlined
                        color="primary"
                        dark
                        class="mb-2"
                        @click="openDialogAddAprover('add', '', '', 'approver')"
                      >
                      <v-icon left dark color="primary" size="14px">fa-plus</v-icon>
                      <span class="ra-text-in-button">
                        เพิ่มผู้ดูแล
                      </span>
                      </v-btn>
                    </v-toolbar>
                  </template> -->
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="ra-border-button mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, approver.indexOf(item), 'approver')"
                        >
                          <template v-slot>
                            <img width="17" height="17" src="@/assets/icons/edit-icon.png" >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="ra-border-button mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'approver')"
                        >
                          <template v-slot>
                            <img width="17" height="17" src="@/assets/icons/delete-icon.png" >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-row v-show="businessType === 'นิติบุคคล2'">
          <v-col cols="12">
            <span class="txt-head">ดาวน์โหลดแบบฟอร์ม<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรุณาดาวน์โหลดแบบฟอร์มในการกรอกข้อมูลเพื่อใช้ในการเพิ่มผู้รักษาการ)</span></span>
          </v-col>
          <v-col cols="12">
            <v-btn
              id="btnbrowse"
              name="btnbrowse"
              right
              rounded
              color="#FFFFFF"
              dark
              class="mr-2 ml-2 pa-5 align-center btn_click"
              @click="getFormAuth()"
            >
              <v-icon left dark color="#6B96F8">fa-file-alt</v-icon>
              <span class="txt-font">แบบฟอร์มหนังสือมอบอำนาจ.doc</span>
              <v-icon right dark color="#6B96F8">fa-download</v-icon>
            </v-btn>
            <v-btn
              id="btnbrowse"
              name="btnbrowse"
              right
              rounded
              color="#FFFFFF"
              dark
              class="mr-0 ml-2 pa-5 align-center btn_click"
              @click="getFormPoa()"
            >
              <v-icon left dark color="#6B96F8">fa-file-alt</v-icon>
              <span class="txt-font">แบบฟอร์มหนังสือมอบอำนาจช่วง.doc</span>
              <v-icon right dark color="#6B96F8">fa-download</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panels>
    </div>
    </v-form>
    <v-dialog v-model="dialogDeleteApprover" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span v-if="titleDialog === 'approver'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้ดูแลคนนี้</span>
        <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogDeleteApprover = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="removeApprover(itemConfirmDelete, titleDialog)">ลบข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogApproverCompany"
      persistent
      max-width="380"
      max-height="232">
      <v-card tile class="justify-center">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกเอกสารนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกเอกสาร</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น"></v-textarea>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogApproverCompany = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="updateStatusApprove()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
    <DialogAddAprover/>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import DialogAddAprover from '../../manageCompany/_dialog/dialogAddApprover'
import {
  getUserByKeyword,
  insertApproveCompany
  // hostImageUrlv3
} from '@/API/API'
const axios = require('axios')

export default {
  components: {
    DialogAddAprover
  },
  name: 'overview',
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDeleteApprover: false,
      dialogApproverCompany: false,
      reqBusinessId: '',
      comment: '',
      titleDialog: '',
      itemConfirmDelete: [],
      panel: [0, 1],
      businessType: 'ธุรกิจ(ร้านค้า)',
      taxDetailType: 'ไม่มีข้อมูลผู้เสียภาษี',
      businessModelType: '',
      itemBusiness: [
        'เกษตรกรรม',
        'การป่าไม้',
        'การประมง',
        'การทำเหมืองแร่ และเหมืองหิน',
        'การผลิต',
        'ไฟฟ้า ก๊าซ ไอน้ำ และระบบการปรับอากาศ',
        'การจัดหาน้ำ',
        'การจัดการน้ำเสีย และของเสีย',
        'การก่อสร้าง',
        'การขายส่ง',
        'การขายปลีก',
        'การซ่อมยานยนต์ และจักรยานยนต์',
        'การขนส่ง และสถานที่เก็บสินค้า',
        'ที่พักแรม',
        'การบริการด้านอาหาร',
        'ข้อมูลข่าวสาร และการสื่อสาร',
        'กิจกรรมทางการเงิน และการประกันภัย',
        'อสังหาริมทรัพย์',
        'วิทยาศาสตร์ และวิชาการ',
        'การบริหาร และบริการสนับสนุน',
        'การบริหารราชการ',
        'การศึกษา'
      ],
      chkDataEmp: 0,
      imageData: null,
      legalEntityTh: '',
      legalEntityEng: '',
      nameUseInDocTh: '',
      nameUseInDocEng: '',
      groupName: '',
      companyNameEng: '',
      companyNameTh: '',
      itemCompany: [],
      taxId: '',
      email: '',
      branchName: '',
      branchCode: '',
      companyTelNo: '',
      companyMobilNumber: '',
      fax: '',
      companyAddressDetail: {
        codeAddress: '',
        address: '',
        roomNo: '',
        floorNo: '',
        buildingName: '',
        villageName: '',
        villageNo: '',
        alley: '',
        dispart: '',
        road: '',
        province: '',
        district: '',
        subDistrict: '',
        postCode: ''
      },
      region: '',
      companyNameFullEng: '',
      companyNameFullTh: '',
      companyNameShortEng: '',
      companyNameShortTh: '',
      address: '',
      files: [],
      filesCertificate: [],
      filesPoa: [],
      filesAuth: [],
      filesCertificateId: '',
      filesCertificateName: '',
      tel: '',
      img: '',
      tab: null,
      imageUrl: '',
      type_files: ['pdf', 'png', 'jpg', 'jpeg', 'tiff', 'gif', 'rar', 'zip', '7z'],
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ],
      userDataStore: '',
      tokenUser: '',
      userIdList: [],
      userIdListTemporary: [],
      approver: [
        // {
        //   no: 1,
        //   _id: '1212xx',
        //   employeeId: 'sittikorn0993',
        //   approverName: 'นายสมพงษ์ อิอิ',
        //   position: 'ตำแหน่ง xxxx',
        //   email: 'kookkai@one.th',
        //   userImg: 'https://picsum.photos/200',
        //   failed_image: true
        // }
      ],
      temporaryer: [],
      isSelecting: false,
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'อีเมล', value: 'email' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersTemporary: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'วันที่รักษาการ', value: '' },
        { text: 'เอกสาร', value: '' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
  },
  // created () {
  //   this.url = process.env.VUE_APP_API_URL
  //   this.port = process.env.VUE_APP_API_PORT
  //   this.api = this.url + ':' + this.port
  //   this.tokenUser = this.$store.state.token
  //   this.getSelectCompany()
  // },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.reqBusinessId = this.$route.params.id
    if (!this.$store.state.token) {
      this.goBack()
    } else {
      this.getSelectCompany()
      await this.getCompanyDetail(this.propsitems)
    }
  },
  computed: {
  },
  watch: {
    legalEntityTh: function (val) {
      if (val === 'ห้างหุ่นส่วนสามัญ') {
        this.legalEntityEng = 'Ordinary Partnership'
      } else if (val === 'ห้างหุ่นส่วนจำกัด') {
        this.legalEntityEng = 'Limited Partnership'
      } else if (val === 'บริษัทจำกัด') {
        this.legalEntityEng = 'Company Limited'
      } else if (val === 'บริษัทมหาชนจำกัด') {
        this.legalEntityEng = 'Public Limited Company'
      } else if (val === 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ') {
        this.legalEntityEng = 'Other'
      } else if (val === 'ไม่มี') {
        this.legalEntityEng = 'None'
      }
    },
    legalEntityEng: function (val) {
      if (val === 'Ordinary Partnership') {
        this.legalEntityTh = 'ห้างหุ่นส่วนสามัญ'
      } else if (val === 'Limited Partnership') {
        this.legalEntityTh = 'ห้างหุ่นส่วนจำกัด'
      } else if (val === 'Company Limited') {
        this.legalEntityTh = 'บริษัทจำกัด'
      } else if (val === 'Public Limited Company') {
        this.legalEntityTh = 'บริษัทมหาชนจำกัด'
      } else if (val === 'Other') {
        this.legalEntityTh = 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ'
      } else if (val === 'None') {
        this.legalEntityTh = 'ไม่มี'
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push('/managebusines')
    },
    cancel () {
      this.files[0] = []
      this.groupName = ''
      this.filesCertificate[0] = []
      this.filesPoa[0] = []
      this.companyNameShortTh = ''
      this.companyNameShortEng = ''
      this.legalEntityTh = ''
      this.companyNameFullTh = ''
      this.nameUseInDocTh = ''
      this.taxId = ''
      this.email = ''
      this.taxId = ''
      this.region = ''
      this.branchName = ''
      this.branchCode = ''
      this.branchName = ''
      this.companyMobilNumber = ''
      this.companyAddressDetail = ''
      this.userIdList = []
      this.userIdListTemporary = []
      this.approver = []
      this.temporaryer = []
      this.$router.go(-1)
    },
    onImgError (i) {
      // console.log('method: ', i)
      this.approver[i].failed_image = true
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectGroupCompany`
      }).then((response) => {
        var dataReverse = response.data.result
        this.itemCompany = dataReverse
        // console.log('revers/e', this.itemCompany)
        this.itemCompany.push({
          _id: '',
          groupCompanyNameEng: 'ไม่มี'
        })
        this.itemCompany = this.itemCompany.reverse()
      }).catch(e => {
        console.log(e)
      })
    },
    async getUserDefault () {
      this.loading = true
      this.loadingUsers = true
      const obj = {
        search: this.$store.state.user.employeeId
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          var filterValue = this.approver.filter(r => {
            if (r.position === res.result[0].position.positionName && r._id === res.result[0].id && r.approverName === res.result[0].name) {
              return r
            }
          })
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คูณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: res.result[0].id,
              employeeId: res.result[0].employeeId,
              approverName: res.result[0].name,
              position: res.result[0].position.positionName,
              email: res.result[0].email,
              userImg: this.api + '/' + res.result[0].userImg,
              approveType: res.result[0].approveType,
              companyId: res.result[0].companyId,
              failed_image: false
            })
            this.userIdList.push({
              userId: res.result[0].id,
              companyId: res.result[0].companyId
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    async downloadFile (value, nameFile) {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + value
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), nameFile)
      }).catch(e => {
        console.log(e)
      })
    },
    async getFormAuth () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจ.doc')
      }).catch(e => {
        console.log(e)
      })
    },
    async getFormPoa () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadSPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจช่วง.docx')
      }).catch(e => {
        console.log(e)
      })
    },
    async getCompanyDetail (id) {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/companys/getReqBusinessById`,
        data: {
          reqBusinessId: id
        }
      }).then((response) => {
        // this.itemCompany = response.data.result.companyName
        if (response.data.result.groupCompanyId === null) {
          // this.groupName = response.data.result.groupCompanyId
          this.groupName = null
        } else {
          this.groupName = response.data.result.groupCompanyId
        }
        this.businessType = response.data.result.businessModelTypeTh
        this.businessModelType = response.data.result.businessModelType
        this.taxDetailType = response.data.result.taxDetail === true ? 'มีข้อมูลผู้เสียภาษี' : 'ไม่มีข้อมูลผู้เสียภาษี'
        this.companyNameShortTh = response.data.result.companyShortNameTh
        this.companyNameShortEng = response.data.result.companyShortNameEng
        this.legalEntityTh = response.data.result.legalEntityTh
        this.companyNameFullTh = response.data.result.companyFullNameTh
        this.nameUseInDocTh = response.data.result.nameUseInDocTh
        this.legalEntityEng = response.data.result.legalEntityEng
        this.companyNameFullEng = response.data.result.companyFullNameEng
        this.nameUseInDocEng = response.data.result.nameUseInDocEng
        this.taxId = response.data.result.taxId
        this.email = response.data.result.email
        this.region = response.data.result.region
        this.branchName = response.data.result.branchName
        this.branchCode = response.data.result.branchCode
        this.companyTelNo = response.data.result.companyTelNo
        this.companyMobilNumber = response.data.result.companyMobilNumber
        this.fax = response.data.result.fax
        this.companyAddressDetail.codeAddress = response.data.result.companyAddressDetail.codeAddress
        this.companyAddressDetail.address = response.data.result.companyAddressDetail.address
        this.companyAddressDetail.roomNo = response.data.result.companyAddressDetail.roomNo
        this.companyAddressDetail.floorNo = response.data.result.companyAddressDetail.floorNo
        this.companyAddressDetail.buildingName = response.data.result.companyAddressDetail.buildingName
        this.companyAddressDetail.villageName = response.data.result.companyAddressDetail.villageName
        this.companyAddressDetail.villageNo = response.data.result.companyAddressDetail.villageNo
        this.companyAddressDetail.alley = response.data.result.companyAddressDetail.alley
        this.companyAddressDetail.dispart = response.data.result.companyAddressDetail.dispart
        this.companyAddressDetail.road = response.data.result.companyAddressDetail.road
        this.companyAddressDetail.province = response.data.result.companyAddressDetail.province
        this.companyAddressDetail.district = response.data.result.companyAddressDetail.district
        this.companyAddressDetail.subDistrict = response.data.result.companyAddressDetail.subDistrict
        this.companyAddressDetail.postCode = response.data.result.companyAddressDetail.postCode
        this.filesCertificateId = response.data.result.companyCertificate
        this.filesCertificateName = response.data.result.companyCertificateName
        // this.imageUrl = this.api + '/' + response.data.result.companyImage
        this.checkImageUrl = response.data.result.companyImage
        this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + response.data.result.companyImage
        const temp = []
        // var resultApprover = response.data.result.userData
        // resultApprover.map((el, index) => {
        //   if (el.userImg === '') {
        //     el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
        //   } else {
        //     el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
        //   }
        //   // el.userImg = this.api + '/api/vMonk/reqEmployee/img/' + el.userImg
        //   el.approverName = el.titleTh + el.firstNameTh + ' ' + el.lastNameTh
        //   temp.push({
        //     approverNo: this.approver.length + 1,
        //     email: el.emailOneId,
        //     failed_image: false,
        //     ...el
        //   })
        //   this.userIdList.push({
        //     userId: el._id,
        //     companyId: el.companyId
        //   })
        //   this.approver = temp
        //   console.log('🚀 ~ approved', temp)
        // })
        temp.push({
          approverNo: this.approver.length + 1,
          approverName: response.data.result.userData.titleTh + response.data.result.userData.firstNameTh + ' ' + response.data.result.userData.lastNameTh,
          email: response.data.result.userData.emailOneId,
          tel: response.data.result.userData.tel,
          failed_image: false,
          ...response.data.result.userData
        })
        this.approver = temp
        var pathFileName = 'uploads/companyFile/' + this.companyNameFullEng + '/'
        var substringsCertificate = response.data.result.companyCertificate.split(pathFileName, 2)
        var substringsPoa = response.data.result.powerOfAttorney.split(pathFileName, 2)
        this.filesPoa.push({
          name: substringsPoa[1]
        })
        this.filesCertificate.push({
          name: substringsCertificate[1]
        })
        // this.approver = response.data.result.companyLeader
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    openDialogAddAprover (action, item, index, type) {
      // console.log('add')
      EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
    },
    add (value, index, action, type) {
      var today = new Date()
      var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()
      var filterValue = this.approver.filter(r => {
        if (r.position === value.position && r.employeeId === value.employeeId) {
          return r
        }
      })
      var filterValueTemporary = this.temporaryer.filter(r => {
        if (r.position === value.position && r.employeeId === value.employeeId) {
          return r
        }
      })
      if (type === 'approver') {
        if (action === 'add') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            // console.log('No Dup', filterValue)
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdList.push({
              userId: value.id,
              companyId: value.companyId
            })
            // console.log('add approver:', this.approver)
            // console.log('add temporaryer:', this.temporaryer)
          }
        } else if (action === 'edit') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver[index].approverNo = index + 1
            this.approver[index]._id = value.id
            this.approver[index].employeeId = value.employeeId
            this.approver[index].approverName = value.name
            this.approver[index].position = value.position
            this.approver[index].email = value.email
            this.approver[index].approveType = value.approveType
            this.approver[index].userImg = value.userImg
            this.approver[index].failed_image = value.failed_image || false
          }
        }
      } else if (type === 'temporaryer') {
        if (action === 'add') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.temporaryer.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdListTemporary.push({
              userId: value.id,
              temporaryDate: date
            })
          }
        } else if (action === 'edit') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.temporaryer[index].approverNo = index + 1
            this.temporaryer[index]._id = value.id
            this.temporaryer[index].employeeId = value.employeeId
            this.temporaryer[index].approverName = value.name
            this.temporaryer[index].position = value.position
            this.temporaryer[index].email = value.email
            this.temporaryer[index].approveType = value.approveType
            this.temporaryer[index].userImg = value.userImg
            this.temporaryer[index].failed_image = value.failed_image || false
          }
        }
      }
    },
    checkRemove (item, type) {
      this.itemConfirmDelete = []
      this.titleDialog = type
      this.itemConfirmDelete = item
      this.dialogDeleteApprover = true
    },
    removeApprover (item, type) {
      // console.log('removeApprover', this.approver.indexOf(item))
      if (type === 'approver') {
        this.approver.splice(this.approver.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      } else if (type === 'temporaryer') {
        this.temporaryer.splice(this.temporaryer.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      }
    },
    async submitDataCreate () {
      this.userDataStore = this.$store.state.user
      var formData = new FormData()
      formData.append('groupCompanyId', this.groupName)
      formData.append('companyFullNameEng', this.companyNameFullEng)
      formData.append('companyFullNameTh', this.companyNameFullTh)
      formData.append('companyShortNameTh', this.companyNameShortTh)
      formData.append('companyShortNameEng', this.companyNameShortEng)
      formData.append('legalEntityTh', this.legalEntityTh)
      formData.append('legalEntityEng', this.legalEntityEng)
      formData.append('nameUseInDocTh', this.nameUseInDocTh)
      formData.append('nameUseInDocEng', this.nameUseInDocEng)
      formData.append('taxId', this.taxId)
      formData.append('email', this.email)
      formData.append('branchName', this.branchName)
      formData.append('branchCode', this.branchCode)
      formData.append('companyTelNo', this.companyTelNo)
      formData.append('companyMobilNumber', this.companyMobilNumber)
      formData.append('fax', this.fax)
      formData.append('companyAddressDetail', JSON.stringify(this.companyAddressDetail))
      // formData.append('companyLeader', JSON.stringify(this.userIdList))
      formData.append('region', this.region)
      formData.append('temporaryLeaderCompany', JSON.stringify(this.userIdListTemporary))
      formData.append('titleTh', this.userDataStore.titleTh)
      formData.append('titleEn', '.')
      formData.append('firstNameTh', this.userDataStore.firstNameTh)
      formData.append('lastNameTh', this.userDataStore.lastNameTh)
      formData.append('firstNameEn', '')
      formData.append('lastNameEn', '')
      formData.append('accountId', '')
      formData.append('birthday', '')
      formData.append('emailUser', this.userDataStore.email)
      formData.append('emailOneId', this.userDataStore.emailOneId)
      formData.append('tel', '')
      formData.append('usernameOneId', '')
      // const obj = formData
      const obj = {
        groupCompanyId: this.groupName,
        companyFullNameEng: this.companyNameFullEng,
        companyFullNameTh: this.companyNameFullTh,
        companyShortNameTh: this.companyNameShortTh,
        companyShortNameEng: this.companyNameShortEng,
        legalEntityTh: this.legalEntityTh,
        legalEntityEng: this.legalEntityEng,
        nameUseInDocTh: this.nameUseInDocTh,
        nameUseInDocEng: this.nameUseInDocEng,
        taxId: this.taxId,
        email: this.email,
        branchName: this.branchName,
        branchCode: this.branchCode,
        companyTelNo: this.companyTelNo,
        companyMobilNumber: this.companyMobilNumber,
        fax: this.fax,
        companyAddressDetail: this.companyAddressDetail,
        region: this.region,
        temporaryLeaderCompany: JSON.stringify(this.userIdListTemporary),
        titleTh: this.userDataStore.titleTh,
        titleEn: '',
        firstNameTh: this.userDataStore.firstNameTh,
        lastNameTh: this.userDataStore.lastNameTh,
        firstNameEn: '',
        lastNameEn: '',
        accountId: '',
        birthday: '',
        emailUser: this.userDataStore.email,
        emailOneId: this.userDataStore.emailOneId,
        tel: '',
        usernameOneId: ''
      }
      // console.log('obj', obj)
      try {
        const res = await insertApproveCompany(obj, this.$store.state.token)
        if (res.success) {
          this.text = 'คุณได้ทำการเพิ่มบริษัทเรียบร้อยแล้ว'
          this.snackbarColor = 'success'
          this.snackbar = true
          // this.$router.go(-1)
          this.$router.push('/manageapprovecompany')
          // console.log('true')
        } else {
          swal('ผิดพลาด', res.data.msg, 'error')
          // this.loading = false
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        // this.loading = false
      } finally {
        // this.loadingEmployeeData = false
      }
    },
    async updateStatusApprove (type) {
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/updateStatusReqBusinessByToken`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          // approveList: confirmList
          reqBusinessId: this.reqBusinessId,
          status: 'cancle',
          role: this.$store.state.user.role[1].permission,
          comment: this.comment
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            this.dialog = false
            this.snackbar = true
            this.page = 1
            this.dialogApproverCompany = false
            this.$router.push('/manageapprovebusiness')
            // self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    addFiles (type) {
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      if (type === 'certificate') {
        this.filesCertificate = []
        var uploadedFilesCertificate = this.$refs.PickfilesCertificate.files
        for (let i = 0; i < uploadedFilesCertificate.length; i++) {
          var dotindexCertificate = uploadedFilesCertificate[i].name.lastIndexOf('.')
          var FileExtension = uploadedFilesCertificate[i].name.substr(dotindexCertificate + 1).toLowerCase()

          if (FileExtension === 'pdf') {
            // console.log(uploadedFiles[i].name, 'ok')
            this.filesCertificate.push(uploadedFilesCertificate[i])
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesCertificate[i].name.substr(-4)}`, 'warning')
          }
        }
      } else if (type === 'poa') {
        this.filesPoa = []
        var uploadedFilesPoa = this.$refs.PickfilesPoa.files
        for (let i = 0; i < uploadedFilesPoa.length; i++) {
          var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
          var FileExtensionPoa = uploadedFilesPoa[i].name.substr(dotindexPoa + 1).toLowerCase()

          if (FileExtensionPoa === 'pdf') {
            this.filesPoa.push(uploadedFilesPoa[i])
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`, 'warning')
          }
        }
      }
    },
    removeFile (key, type) {
      if (type === 'certificate') {
        this.filesCertificate.splice(key, 1)
        const input = this.$refs.PickfilesCertificate
        input.type = 'text'
        input.type = 'file'
      } else if (type === 'poa') {
        this.filesPoa.splice(key, 1)
        const input = this.$refs.PickfilesPoa
        input.type = 'text'
        input.type = 'file'
      }
      // // console.log('remove key', key)
      // console.log('FILE ', this.files)
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name.substr(dotindex + 1).toLowerCase()
      if (FileExtension === 'jpg' || FileExtension === 'png' || FileExtension === 'JPG' || FileExtension === 'PNG') {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var img = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          img.src = evt.target.result
        }
        // reader.onerror = evt => {
        //   console.error(evt)
        // }
      } else {
        swal('คำเตือน', `ไม่รองรับไฟล์${uploadedImage[0].name.substr(-4)}`, 'warning')
      }
    },
    copyData () {
      // this.$router.push('managebusines/create')
      this.$router.push({
        name: 'manageBusinescreate',
        params: {
          type: 'copy',
          id: this.reqBusinessId
        }
      })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.base-image-input {
  display: block;
  width: 100px;
  height: 100px;
  /* padding: 8%; */
  border-radius: 5px;
  cursor: unset;
  background-size: contain;
  background-position: center center;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.placeholder-image {
  /* background: #F0F0F0; */
  background-image: url('../../../assets/icons/no-company-7.png');
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: 'Sarabun', sans-serif;
}
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url('../../../assets/icons/no-company-7.png');

}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
</style>
